/* Copyright 2013-2015 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/dom-construct"
], function (declare, domConstruct) {
    return declare(null, {
        constructor: function () {
            this._wrappers = {};
            this._childrenWidgets = [];
        },

        addChild: function (widget, index) {
            var wrapper = domConstruct.create("div", {
                id: widget.id + "_wrapper",
                "class": "toolstripComponentWrapper"
            }, this.containerNode, index);

            if (index >= 0) {
                this._childrenWidgets.splice(index, 0, widget);
            } else {
                this._childrenWidgets.push(widget);
            }

            this.own(widget);

            domConstruct.place(widget.domNode, wrapper);

            // Following the pattern in _Container
            if (this._started && !widget._started) {
                widget.startup();
            }

            this._wrappers[widget.id] = wrapper;
        },

        removeChild: function (widget) {
            var index, wrapper = this._wrappers[widget.id];

            this._childrenWidgets.forEach(function (w, i) {
                if (widget.id === w.id) {
                    index = i;
                }
            });

            this._childrenWidgets.splice(index, 1);

            if (wrapper) {
                if (widget.domNode) {
                    wrapper.removeChild(widget.domNode);
                }
                domConstruct.destroy(wrapper);
                delete this._wrappers[widget.id];
            }
        },

        getChildren: function () {
            return this._childrenWidgets;
        }
    });
});

